import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class Renuncia extends BaseEntity {
    ide: number;
    usuarioResponsavel: string;
    dataCriacao: Date;
    valorRenuncia: number;
    nomeAgenteFinanceiro: string;
    valorDescomprometidoNovasContratacoes: number;
    acrescimoExclusivoAoLimiteRenunciante: number;
}

export class RenunciaDetalheDto {
    ide: number;
    nomeAgenteFinanceiro: string;
    cnpjAgenteFinanceiro: string;
    razaoSocialAgenteFinanceiro: string;
    ideUsuarioResponsavel: string;
    dataAceite: Date;
    dataSubstituicao: Date;
    usuarioResponsavelSubstituicao: string;
    dataSolicitacao: Date;
    idProtocoloNegocioLoteOriginalTela: string;
    arquivoEnvio: string;
    arquivoResposta: string;
    mensagem: string;
    statusSolicitacao: string;
    valorRenunciado: number;
    valorDistribuicao1: number;
    valorDistribuicao2: number;
    valorDistribuicao3: number;
    valorDistribuicao4: number;
    valorDistribuicao5: number;
    valorDistribuicao6: number;
    valorDistribuicao7: number;
    valorDistribuicao8: number;
    valorDistribuicao9: number;
    dataExclusao: number;
    usuarioResponsavelExclusao;
    valorDescomprometidoNovasContratacoes: number;
    acrescimoExclusivoAoLimiteRenunciante: number;

}

export class JanelaRenunciaResponseDto {
    dataCriacao: Date;
    dataInicioVigencia: Date;
    dataFimVigencia: Date;
    usuarioResponsavelCadastroJanela: string;
    tipoJanela: string;
}

export class ApuracaoRenunciaDto {
    agenteFinanceiro: string;
    cnpj: string;
    sigla: string;
    valorRenunciado: number;
    valorDistribuicao1: number;
    valorDistribuicao2: number;
    valorDistribuicao3: number;
    valorDistribuicao4: number;
    valorDistribuicao5: number;
    valorDistribuicao6: number;
    valorDistribuicao7: number;
    valorDistribuicao8: number;
    valorDistribuicao9: number;
    dataHoraApuracao: Date;
    ideUsuarioResponsavel: string;
    totalPorBimestre: number;
    bimestre: number;
    mesAnoApuracao: Date;
}

export class ValorDistribuicaoAgenteFinanceiroApuracaoRenuncia {
    valorTotalRenunciadoDescomprometidoApurado: number;
    bimestreApuracaoAtual: number;

}

export const TIPO_JANELA_RENUNCIA_COBERTURA_MAXIMA = '1';
export const TIPO_JANELA_RENUNCIA_LIMITE_ADICIONAL = '2';

export const TIPO_JANELA_VALIDACAO = [
    {
        value: null,
        label: ''
    },
    {
        value: '1',
        label: 'Renúncia à Cobertura Máxima de Inadimplência'
    },
    {
        value: '2',
        label: 'Renúncia Limite Adicional'
    }
]
